import { useEffect } from 'react';

export default function StudioRedirectInterstitial() {
  useEffect(() => {
    const timer = setTimeout(() => {
      try {
        window.location.replace('/admin/sign-in');
      } catch (err) {
        // In test envs window.location.replace may be mocked or readonly.
      }
    }, 700);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      data-testid="studio-redirect-interstitial"
      aria-live="polite"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        color: 'rgb(226,232,240)',
        background: '#0f1115',
        fontFamily: 'Outfit, system-ui, -apple-system, sans-serif',
      }}
    >
      Redirecting to studio.metaphysical-labs.com/admin/sign-in
    </div>
  );
}
